import * as React from "react";
import { Link, RouteComponentProps } from "react-router-dom";
import Breadcrumbs from "../core/Breadcrumbs";
import usePromise from "../hooks/usePromise";
import ModernCard from "../core/ModernCard";
import {
  getCommissionConfigs,
  updateEmployeeCommissionConfig,
} from "../../libs/commission_calculator";
import Select from "react-select";
import { useContext, useEffect, useRef, useState } from "react";
import Button from "../core/Button";
import CommissionConfigViewModal from "./CommissionConfigViewModal";
import CommissionsTable from "./CommissionsTable";
import { compact } from "lodash";
import { RailsUserContext } from "../../libs/user_context";

interface IProps extends RouteComponentProps {
  user: IUser;
  commissions: ICommissionMonth[];
  commissionsPromise: IUsePromiseBag;
}

function CommissionUser({
  user,
  history,
  location,
  commissions,
  commissionsPromise,
}: IProps) {
  const { user: currentUser } = useContext(RailsUserContext);

  const isAdminView = currentUser.organization.id !== user.organization.id;

  const [viewingConfig, setViewingConfig] = useState(false);

  const [selectedConfigId, setSelectedConfigId] = useState(null);

  const selectedConfigInit = useRef(false);
  useEffect(() => {
    if (!selectedConfigInit.current && user) {
      if (user.commissionConfig) {
        setSelectedConfigId(user.commissionConfig.id);
      }
      selectedConfigInit.current = true;
    }
  }, [user]);

  const [configs, { loading: loadingConfigs }] = usePromise(() =>
    getCommissionConfigs(user.organization.id).then(cfgs =>
      cfgs.filter(c => !c.archived)
    )
  );

  const config =
    configs && selectedConfigId
      ? configs.find(c => c.id === selectedConfigId)
      : null;

  async function updateConfig(configId) {
    setSelectedConfigId(configId);
    await updateEmployeeCommissionConfig(user.id, configId);
  }

  return (
    <>
      <Breadcrumbs
        crumbs={compact([
          { label: "Commission Calculator", route: "/", routerLink: true },
          isAdminView
            ? { label: "Admin", route: "/admin", routerLink: true }
            : null,
          { label: user ? user.name : "..." },
        ])}
      />
      <div className="level">
        <div className="level-left">
          <div className="level-item">
            <Link
              to={isAdminView ? "/admin" : "/"}
              className={"btn btn-primary"}
            >
              <i className="fa fa-arrow-left" /> Back to Commission Calculator
              HomePage
            </Link>
          </div>
        </div>
      </div>
      <ModernCard title={"Configuration"} ta="left" m="0px">
        <p>This is the configuration that will be used for new months.</p>
        <div className="columns is-vcentered">
          <div className="column">
            <Select
              options={
                configs
                  ? configs.map(c => ({ label: c.name, value: c.id }))
                  : []
              }
              onChange={(opt: ISelectOption) => updateConfig(opt.value)}
              value={config ? { label: config.name, value: config.id } : null}
              clearable={false}
              isLoading={loadingConfigs}
              disabled={isAdminView}
            />
          </div>
          <div className="column is-narrow">
            <Button onClick={() => setViewingConfig(true)} color={"info"}>
              <i className="fa fa-eye" /> View
            </Button>
          </div>
        </div>
        {!selectedConfigId && (
          <p className={"text-danger"}>
            You must set a configuration for this user before starting a
            commission month.
          </p>
        )}
      </ModernCard>
      <ModernCard title={"Commissions"} ta="left" m="0px">
        <CommissionsTable
          commissions={commissions}
          commissionsPromise={commissionsPromise}
          user={user}
          selectedConfigId={selectedConfigId}
          history={history}
          isAdminView={isAdminView}
        />
      </ModernCard>
      {config && (
        <CommissionConfigViewModal
          open={viewingConfig}
          close={() => setViewingConfig(false)}
          config={config}
        />
      )}
    </>
  );
}

export default CommissionUser;



// WEBPACK FOOTER //
// ./app/javascript/components/commission_calculator/CommissionUser.tsx